import {useTranslation} from "react-i18next";
import React, {useEffect} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import liff from "@line/liff";
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";

const LineButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#000000"),
    backgroundColor: "#06C755",
    '&:hover': {
        backgroundColor: "#06C755",
    },
}));


export default function LineOAFriendship() {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);

    const lineAuthentication = async(cb) => {
        const liffId = process.env.REACT_APP_LINE_SIGNIN_LIFF_ID;
        await liff.init({ liffId: liffId, withLoginOnExternalBrowser: true }).catch(err=>{throw err});
        if (liff.isLoggedIn()) {
            return cb(true);
        }else{
            return cb(false);
        }
    };

    useEffect(() => {
        console.log('[LineOAFriendship]')
        lineAuthentication(function (r) {
            if (r) {
                liff.getFriendship().then((data) => {
                    if(data){
                        if(!data.friendFlag){
                            setOpen(true);
                        }
                    }
                });
            }
        }).then(r  =>{});
    }, []);

    const handleAddFriend = () => {
        setOpen(false);
        window.location.href = `https://line.me/R/ti/p/%40foodkub.merchant`
    };

    return(
        <div>
            <Dialog open={open}>
                <DialogTitle style={{textAlign: "center", color: "#06C755", fontWeight: 800}}>
                    {t('lineOA.line')}
                </DialogTitle>
                <Box m={2} mt={0}>
                    <Box display={"flex"} justifyContent={"center"}>
                        <Avatar
                            alt="FoodKub Merchant"
                            src={`${process.env.REACT_APP_CDN_BASE_URL}/public/assets/foodkub_merchant_icon_512.jpg`}
                            sx={{ width: 72, height: 72 }}
                        />
                    </Box>
                    <Box pl={4} pr={4} mb={2} mt={1} display={"flex"}
                         justifyContent="center"
                         alignItems="center">
                        <img style={{width: '15px'}} src={`${process.env.REACT_APP_CDN_BASE_URL}/public/assets/line-oa-shield-verified.png`} alt={"line verified"} />
                        <Typography variant={"subtitle1"} ml={1}>
                            <strong>{t('lineOA.foodKubMerchant')}</strong>
                        </Typography>
                    </Box>
                    <LineButton edge="start"
                                fullWidth={true}
                                startIcon={<img alt="LINE" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDphNTk0YTczYS0zNzEzLTRhMjktODgyYi0xYjg0ZWJkMjM5NGQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEFCNUUyREQ5M0YwMTFFNDk1OEFENjBBMUJBQjkyMzkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEFCNUUyREM5M0YwMTFFNDk1OEFENjBBMUJBQjkyMzkiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6YzU4NjU0YTItOWNhYy00OWU0LThkNjgtMmMwZjU4OTkxNjIzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmE1OTRhNzNhLTM3MTMtNGEyOS04ODJiLTFiODRlYmQyMzk0ZCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pg+/OCAAAAHESURBVHja7Ne/LwNhGMDxHiUkEhODxHIlYRKLWPzYDMIowUhsIiLB4EeCwURC/AsSi6G7FDWKBG3CoNIBCWnoJFp6vpc8w5vmGu/bXnTpk3yGe+7ufZ/eve97by3HcQLljKpAmaNSQKWAoOH1XRjBAEJolvwrHnCOMK61W3SnoYZBRBz9iMg9f7b91wVB7CHnmEdO7g0WW0A1jp3S41jaMi5g0/Evtgr1YxVYim3cocanwZ5FpwxUrWk4rXT+g0V8y3Ea60hhSc67sSG5WYxhHEk557Y1ZTIL4srj+5BcUo5v0Iio5Nckr+aWsY0XpZ24V1+FnoCt+WhrsYtTj3NW3jpjm6yEn5oF1EsBk8go+Vtc4r3YpTjhkbvAiQwoNdx325dX9ARm0KrkYiZjYF15d1/oho02nGEIjxhWxkk/EuiRa0O4UtpZNZmGLbhHg0/TMC3fjpTuK3jGio8fvTmvznU+Rvs+rII7pXyMXPMyDoqJA1ilFhCQwXeEjGbHWSzotG0ZbsubZUPSK5uSdo9rnmQZjvq5IfHiFh/L++VhNJm0U8qeUH10KVkNR/H2n5vSOuyjA4fFNGBV/ppVCih3Ab8CDAAenITLwKlYUgAAAABJRU5ErkJggg==" />}
                                variant="contained"
                                onClick={handleAddFriend}
                                size={"large"}
                                aria-label="add friend">
                        <Typography variant="subtitle1">{t('lineOA.addFriend')}</Typography>
                    </LineButton>
                </Box>
            </Dialog>
        </div>
    )
}